module.exports = __webpack_public_path__ + "static/media/preAdvise.2b42c64a.svg";